import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import { PAGES, applyHead } from "@/seo/site";

Vue.use(VueRouter);

/**
 * 按路由名称或路径取页面 SEO 配置。
 * @param {import('vue-router').Route} to
 * @returns {Object}
 */
function resolvePage(to) {
  if (to.name && PAGES[to.name]) {
    return PAGES[to.name];
  }
  if (to.name === "newsdetail") {
    return Object.assign({}, PAGES.newsdetail, {
      path: to.path,
    });
  }
  return PAGES.notFound;
}

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/about",
    name: "about",
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/solutions",
    name: "solutions",
    component: () =>
      import(/* webpackChunkName: "solutions" */ "../views/SolutionView.vue"),
    meta: { pageKey: "solutions" },
  },
  {
    path: "/solutions/bulk-freight",
    name: "bulk",
    component: () =>
      import(/* webpackChunkName: "solutions" */ "../views/SolutionView.vue"),
    meta: { pageKey: "bulk" },
  },
  {
    path: "/solutions/steel-cement",
    name: "steel",
    component: () =>
      import(/* webpackChunkName: "solutions" */ "../views/SolutionView.vue"),
    meta: { pageKey: "steel" },
  },
  {
    path: "/solutions/new-energy-truck",
    name: "energy",
    component: () =>
      import(/* webpackChunkName: "solutions" */ "../views/SolutionView.vue"),
    meta: { pageKey: "energy" },
  },
  {
    path: "/faq",
    name: "faq",
    component: () => import(/* webpackChunkName: "faq" */ "../views/Faq.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: () => import(/* webpackChunkName: "news" */ "../views/News.vue"),
  },
  {
    path: "/companynews",
    name: "companynews",
    component: () =>
      import(/* webpackChunkName: "news" */ "../views/OurNews.vue"),
  },
  {
    path: "/newsdetail/:id?",
    name: "newsdetail",
    component: () =>
      import(/* webpackChunkName: "news" */ "../views/NewsDetail.vue"),
  },
  {
    path: "/truckage",
    name: "truckage",
    component: () =>
      import(/* webpackChunkName: "truckage" */ "../views/showtruckage.vue"),
  },
  {
    path: "/404",
    name: "notFound",
    component: () =>
      import(/* webpackChunkName: "notfound" */ "../views/NotFound.vue"),
  },
  {
    path: "*",
    name: "notFoundCatch",
    component: () =>
      import(/* webpackChunkName: "notfound" */ "../views/NotFound.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.afterEach(function (to) {
  const page = resolvePage(to);
  applyHead(page);
  Vue.nextTick(function () {
    document.dispatchEvent(new Event("render-event"));
  });
});

export default router;
